
export const followupEndpoints = { 
    postFilterCalender: '/api/ReFollowUp/FilterCalender', 
};